import React from 'react'
import { fmt, arrayFrom, isEmpty } from '../twd'
import { useTreasuryAuctions } from './use-treasury-auctions'

const download = (url) => {
    const a = document.createElement("a")
    a.href = url
    a.download = url.split('/').pop()
    a.target="_blank"
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}

export default () => {
    const { upcoming } = useTreasuryAuctions()
    const hasUpcoming = !isEmpty(upcoming)

    return <React.Fragment>
    <div className="row vertical-offset-xs"></div>

    <div className="row">
    <div className="col-xs-12">
        <div className="medium-header">Upcoming auctions</div>
    </div>
    </div>

    { !hasUpcoming && <EmptyMsg />}

    { hasUpcoming && <Table /> }


    <div className="row vertical-offset-sm">
    <div className="col-xs-12 text-center">
        <button
            className="btn btn-lg btn-primary-outline"
            onClick={() => download('https://home.treasury.gov/system/files/221/Tentative-Auction-Schedule.pdf')}
        >
            Download the Treasury's tentative auction schedule
        </button>
    </div>
    </div>

    <div className="row vertical-offset-sm">
    <div className="col-xs-12 ">
    ^ The Treasury establishes a maximum non-competitive bid limit of $10 million per household, per auction.
    </div>
    </div>

    <div className="row vertical-offset-sm">
    <div className="col-xs-12 ">
    † The indicative yield value is an estimated yield that is derived from the most recently issued treasury security of a similar maturity.
    The indicative yield may be unavailable for some auctions (TIPS, FRNs).
    Please note indicative yields are for informational purposes and do not necessarily represent the final yield level at which the auction will be issued.
    The actual yield for a given auction may be higher or lower than the indicative yield.
    The indicative yield is not a commitment by Morgan Stanley Wealth Management to trade at any price.
    </div>
    </div>
    </React.Fragment>
}

const EmptyMsg  = () =>
    <div className="col-md-12 text-center">
    <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
    <div className="small-header">There are currently no upcoming Treasury auctions.</div>
    <p>Check the upcoming auctions table for the tentative schedule.</p>
    </div>

const Table = () => {
    const { upcoming } = useTreasuryAuctions()

    return <React.Fragment>
    <div className="row vertical-offset-base">
    <div className="col-xs-12 table-responsive">
        <table className="table table-striped">
        <thead>
            <tr>
            <th className="col-md-9">Issue</th>
            <th className="col-md-3 text-right">Auction Open</th>
            </tr>
        </thead>
        <tbody>
            { arrayFrom(upcoming)
                .map(({description, auctionDate},i) => {
                    return <tr key={i}>
                        <td>{description}</td>
                        <td className="text-right">{fmt.mdy(auctionDate)}</td>
                    </tr>
                })
            }
        </tbody>
        </table>
    </div>
    </div>
    </React.Fragment>
}